module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n      การใช้งาน Biomatic\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-atomic"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Atomic Class คือหัวใจหลักของ Biomatic เปรียบเสมือนกล่องเครื่องมือที่คุณใช้งานบ่อย เป็น Class ที่ใช้กำหนด Style เพียงอย่างใดอย่างหนึ่ง\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n      คุณสามารถใช้ Atomic Class หลายๆ Class ประกอบกันเพื่อเป็นผลลัพธ์ที่คุณต้องการได้\n      หรือใช้งานร่วมกับ Class อื่นๆ เพื่อปรับแต่งการแสดงผลให้เป็นไปตามที่คุณต้องการ 😲\n    ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      ปัญหาของ Atomic Framework โดยทั่วไปคือชื่อ Class นั้นหลายครั้งไม่มีรูปแบบชัดเจนและคาดเดาได้ยาก เนื่องจาก\n      ความพยายามในการตั้งให้มีความสั้นเกินไป หรือยาวเกินไป 😅\n    ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n      Value ก็ใช้กฏแบบเดียวกัน (ยกเว้นค่าคงที่ของ Biomatic เช่น Color Name)\n    ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n      ตัวอย่าง\n    ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "_fs-4 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n      Responsive ใน Atomic Class\n    ")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "_fs-4 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n      Hover ใน Atomic Class\n    ")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-component"
    }
  }), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Component Class")]), _vm._v(" ใช้เพื่อแสดงผล Elements พื้นฐาน เช่น\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentButton'
      }
    }
  }, [_vm._v("Button")]), _vm._v(",\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentLink'
      }
    }
  }, [_vm._v("Link")]), _vm._v(",\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentCard'
      }
    }
  }, [_vm._v("Card")]), _vm._v(" หรือ\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentForm'
      }
    }
  }, [_vm._v("Form")])], 1), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Component Class สามารถใช้ Options เพื่อเปลี่ยนรูปแบบการแสดงผลของ Style, Color หรือ State ได้\n    ")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-layout"
    }
  }), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Responsive Grid Layout เป็นเทคนิคพื้นฐานที่ใช้จัดการ Layout สำหรับหลายขนาดหน้าจอ\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Biomatic จะมีการใช้งาน Responsive Grid ที่แตกต่างกับ Framework อื่นๆ\n      คือ เราจะกำหนด Layout ที่ Container เพียงอย่างเดียวเท่านั้น 🤔\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      สาเหตุที่เรากำหนด Layout ที่ Container ก็เพราะว่าเราจะลด Element ด้านในที่ไม่จำเป็นออกไป\n      ให้ DOM มีความซับซ้อนน้อยที่สุด และเพื่อแยก Element ที่ทำหน้าที่เป็น Layout และ Component อย่างชัดเจน\n    ")]), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      นอกจากนี้ Layout Class ยังสามารถกำหนด Option เพื่อกำหนดรายละเอียดต่างๆ เช่น Grid Gutter ได้อีกด้วย 😍\n    ")]), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-utility"
    }
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Utility Class ใช้สำหรับกำหนดลักษณะต่างๆ ที่ Biomatic เตรียมไว้ เช่น Animation, Hover behavior\n      โดยสามารถร่วมกับ Class อื่นๆ ได้ทั่วไป\n    ")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'Installation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  วิธีติดตั้ง\n        ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      }
    }
  }, [_vm._v("\n          Alignment   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-64px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n      Biomatic แบ่งการใช้งานเป็นดังต่อไปนี้ "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-atomic"
    }
  }, [_vm._v("ใช้งาน Atomic Class")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-component"
    }
  }, [_vm._v("ใช้งาน Component Class")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-layout"
    }
  }, [_vm._v("ใช้งาน Layout Class")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-utility"
    }
  }, [_vm._v("ใช้งาน Utility Class")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-atomic"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน Atomic Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n      Atomic Class ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_")]), _vm._v(" ตามด้วยชื่อ Class\n      ที่เป็นคู่ของ "), _c('strong', [_vm._v("Name")]), _vm._v(" และ "), _c('strong', [_vm._v("Value")]), _vm._v(" เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_mg-8px")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_pdt-16px")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_w-100pct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n      สำหรับ Biomatic เราต้องการให้ผู้ใช้งานไม่จำเป็นต้องมีการจำชื่อ Class จึงกำรูปแบบการตั้งชื่อขึ้นมาคือ\n      "), _c('u', [_vm._v("ใช้ตัวย่อตามเสียงที่ออก")]), _vm._v(" เช่น "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("margin")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_mg")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("margin-button")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_mgbt")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("text-align")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_tal")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("position")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_pst")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("16 pixel")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("16px")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("100 percentage")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("100pct")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("center")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("ct")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("inline-block")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("ilb")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("auto")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("at")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("padding-top: 64px")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_pdt-64px")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("width: 100%")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_w-100pct")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("cursor: pointer")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_cs-pt")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("display: inline-block")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_dp-ilb")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      จนถึงตรงนี้คุณน่าจะเข้าใจแนวคิด และรู้ว่า Atomic Class\n      ที่คุณจะใช้ควรมีหน้าตาแบบไหนโดยไม่ต้องอ่าน Document\n      (คุณลองเดาชื่อ Atomic Class ของ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("float: left")]), _vm._v(" หรือ "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("position: absolute")]), _vm._v(" ดูสิ! 😄)\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Atomic Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\ntext-align: center,\npadding: 16px,\ncolor: white (เป็นค่าคงที่ของ Biomatic),\nbackground-color: primary (เป็นค่าคงที่ของ Biomatic),\nborder-radius: 4px,\nfont-size: 4 (เป็นค่าคงที่ของ Biomatic)\n-->\n<div class=\"_tal-ct _pd-16px _fs-4 _cl-white _bgcl-primary _bdrd-4px\">\n  Content\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px _pd-8px"
  }, [_c('div', {
    staticClass: "_tal-ct _pd-16px _fs-4 _cl-white _bgcl-primary _bdrd-4px"
  }, [_vm._v("Content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Atomic Class สามารถใช้งาน Breakpoint\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-sm")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-md")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-lg")]), _vm._v("\n      ที่ Class เพื่อให้แสดงผลที่ขนาดหน้าจอใดๆ ขึ้นไป ในการทำ Responsive Style ได้ 😄\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Breakoint ใน Atomic Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\nContainer\ntext-align: center,\ntext-align: left when small size screen,\ntext-align: right when medium size screen,\n\nBox\ndisplay: inine-block,\nwidth: 32px,\nheight: 32px,\nbackground-color: negative (เป็นค่าคงที่ของ Biomatic),\nbackground-color: positive (เป็นค่าคงที่ของ Biomatic) when small size screen,\n-->\n<div class=\"_tal-ct _tal-l-sm _tal-r-md\">\n  <div class=\"_dp-ilb _w-32px _h-32px _bgcl-negative _bgcl-positive-sm\"></div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px _pd-8px"
  }, [_c('div', {
    staticClass: "_tal-ct _tal-l-sm _tal-r-md"
  }, [_c('div', {
    staticClass: "_dp-ilb _w-32px _h-32px _bgcl-negative _bgcl-positive-sm"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Atomic Class ที่เกี่ยวกับ Color ได้แก่ Color, Background Color และ Border Color จะสามารถใส่\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-hover")]), _vm._v("\n      ที่ Class เพื่อให้แสดงผลที่ Class เมื่อ Hover State ได้ 😄\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Hover ใน Atomic Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_h-32px _bgcl-positive _bgcl-negative-hover _cl-white _cl-black-hover\">\n  <strong>Hello</strong>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel  _mgbt-128px _pd-8px"
  }, [_c('div', {
    staticClass: "_h-32px _bgcl-positive _bgcl-negative-hover _cl-white _cl-black-hover"
  }, [_c('strong', [_vm._v("Hello")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-component"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" ใช้งาน Component Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n      Component Class ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-")]), _vm._v(" ตามด้วย Value เป็นชื่อ Component เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-button")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-link")]), _vm._v(" หรือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-accordion")]), _vm._v(" เป็นต้น\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Option Class จะใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-")]), _vm._v(" ตามด้วยชื่อ Option เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-disabled")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-fancy")]), _vm._v(" หรือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-loading")]), _vm._v(" เป็นต้น 😲\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน bio-button รูปแบบต่างๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button\"></div>\n<div class=\"bio-button -positive\"></div>\n<div class=\"bio-button -negative\"></div>\n<div class=\"bio-button -negative -outline\"></div>\n<div class=\"bio-button -loading\"></div>\n<div class=\"bio-button -disabled\"></div>\n<div class=\"bio-button -negative -disabled -loading\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-48px u-panel"
  }, [_c('div', {
    staticClass: "bio-button _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -positive")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -negative")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -negative -outline")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -loading _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -loading")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -disabled _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -disabled")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -disabled -loading _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -negative -disabled -loading")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n      จะสังเกตว่ารูปแบบการเขียนลักษณะนี้ จะหมือนกับ Switched ใน UNIX commandline เช่น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("ls -a")]), _vm._v(" เป็นต้น 🤔\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-128px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – คุณ"), _c('u', [_vm._v("ไม่")]), _vm._v("ควรใส่ Component Class มากกว่าหนึ่ง Class\n        ที่ Element เดียวกัน เพราะ Element แต่ละอันควรทำหน้าที่เพียงอย่างเดียวเท่านั้น\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-layout"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน Layout Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Layout ที่ซับซ้อนมากๆ ถ้าใช้การกำหนด Layout แบบทั่วไปคุณจะพบว่า DOM\n      จะมีระดับชั้นของ Nested "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("<div>")]), _vm._v("\n      ที่ใช้เพียงเพื่อสร้าง Layout ที่ลึกมาก หรือที่เรียกว่า \"divitis\" 😱\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างของ \"Divitis\"")]), _vm._v(" 🙅🙅🙅\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "_mgbt-48px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class='image'>\n  <div class='shadow'>\n    <div class='bottom-shadow'>\n      <div class='content'>\n        <img src=\"...\" alt=\"\" />\n      </div>\n    </div>\n  </div>\n  <div class=\"actions\">\n    <div class=\"action item\">\n      <div class=\"button-container\">\n        <div class=\"button\">\n          Click Me\n        </div>\n      </div>\n    </div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _mgbt-48px"
  }, [_c('p', {
    staticClass: "_fs-6"
  }, [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – Biomatic แนะนำให้คุณใช้ "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "http://learncssgrid.com/",
      "target": "_blank"
    }
  }, [_vm._v("CSS Grid")]), _vm._v(" สำหรับ Layout ที่มีซับซ้อน 👍 "), _c('br'), _vm._v("\n        (ปัจจุบัน "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "https://caniuse.com/#feat=css-grid",
      "target": "_blank"
    }
  }, [_vm._v("Support Modern Browser")]), _vm._v(" แล้ว)\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Layout Class ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-")]), _vm._v("\n      ตามด้วย Value เป็นขนาดของ Grid ที่ต้องการ\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Biomatic ใช้ Grid 12 เป็น Grid Systems ซึ่งสามารถกำหนด Value เป็นค่าที่หาร 12 ลงตัว คือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-1")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-2")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-3")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-4")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-6")]), _vm._v(" และ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-12")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n      หรือ คู่ของผลรวม ที่รวมกันได้ 12 เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-4-8")]), _vm._v(" หรือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-9-3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Layout Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-4 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<div class=\"lo-8-4 -gapv-16px -gaph-4px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-48px _pd-8px u-panel "
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-4")]), _vm._v(" "), _c('div', {
    staticClass: "lo-4 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gapv-16px -gaph-4px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n      Layout Class สามารถใส่ Breakpoint\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-sm")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-md")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-lg")]), _vm._v("\n      ที่ Class เพื่อแสดงผลที่ขนาดหน้าจอใดๆ เพื่อใช้ในการทำ Responsive Grid\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-48px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – Biomatic ไม่มี Breakpoint "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-xs")]), _vm._v("\n        เพราะเรายึดหลักแนวคิดของ Progressive Enhancement หรือ Mobile First นั่นคือเรากำหนด Interface ของ\n        Mobile เป็นพื้นฐานก่อน และตามด้วย Interface ที่ขนาดหน้าจอที่ใหญ่ขึ้น 😤\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Breakpoint ใน Layout Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-12 lo-9-3-sm lo-3-lg -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-128px _pd-8px u-panel "
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v("lo-12 lo-9-3-sm lo-3-lg")]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-9-3-sm lo-3-lg -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-utility"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน Utility Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("u-")]), _vm._v(" แล้วตามด้วย Value เป็นชื่อ Utility ของ Biomatic\n      เช่น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("u-animation-pulse")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("u-rise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button u-animation-pulse\">bio-button u-animation-pulse</div>\n<div class=\"bio-button u-rise\">bio-button u-rise</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-48px _pd-8px u-panel"
  }, [_c('div', {
    staticClass: "bio-button _mgbt-24px u-animation-pulse"
  }, [_vm._v("bio-button u-animation-pulse")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button u-rise"
  }, [_vm._v("bio-button u-rise")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01cf65ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/GettingStart.vue
// module id = 107
// module chunks = 0